import { useI18n } from 'next-localization';

import { useBasePath } from '@/hooks/use-base-path';
import { useCustomRouting } from '@/hooks/use-custom-routing';
import { NeuButton, NeuChangeEvent, NeuCheckbox, NeuModal } from '@hcahealthcaredpx/neutron-react';

export const LeaveSiteModal = ({
  show,
  setShow,
  url,
  onLeave,
}: {
  show: boolean;
  setShow: (value: React.SetStateAction<boolean>) => void;
  url?: string;
  onLeave?: () => void;
}): JSX.Element => {
  const { t } = useI18n();
  const { withBasePath } = useBasePath();
  const { routerPush } = useCustomRouting();

  return (
    <NeuModal
      active={show}
      size="small"
      onNeuDismiss={() => setShow((p) => !p)}
      label={t('OAS.Booking.Confirmation.LeaveSiteTitle')}
      backdropDismiss
    >
      <NeuModal.Content>
        {t('OAS.Booking.Confirmation.LeaveSiteDescription')}
        <div className="d-flex mt-1 align-items-center">
          <NeuCheckbox
            label={t('OAS.Booking.Confirmation.LeaveSiteCheckboxText')}
            checked={false}
            onNeuChange={(e: NeuChangeEvent & { checked: boolean }) => {
              if (e.checked) {
                sessionStorage.setItem('bookingAlertDismissed', 'true');
                return;
              }
              sessionStorage.setItem('bookingAlertDismissed', 'false');
            }}
          />
        </div>
      </NeuModal.Content>
      <NeuModal.Footer>
        <NeuButton
          onClick={() => {
            setShow(false);
            if (url) {
              routerPush(withBasePath(url));
              return;
            }
            onLeave?.();
          }}
        >
          {t('OAS.Booking.Confirmation.LeaveSiteLeaveButton')}
        </NeuButton>
        <NeuButton kind="secondary" onClick={() => setShow(false)}>
          {t('OAS.Booking.Confirmation.LeaveSiteCancelButton')}
        </NeuButton>
      </NeuModal.Footer>
    </NeuModal>
  );
};
